import OtherHoldingDocuments from "./other-holding-documents";

export default OtherHoldingDocuments;
